module.exports = __webpack_public_path__ + "static/media/1031865.e5cf1dec.jpg";